import styled from "styled-components";

export const Wrapper = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: "1 0 auto",
}));

export const MainContent = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.bgPage,
  paddingTop: 50,
  paddingBottom: 50,
  [theme.down("md")]: {
    paddingTop: 30,
    paddingBottom: 30,
  },
  [theme.down("sm")]: {
    paddingTop: 20,
    paddingBottom: 20,
  },
}));
